import { useEffect, useRef, useState } from "react";
import moment from "moment";
// import MainFilterHandler from ".";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import MainHeading from "../../../components/comman/MainHeading";
import CommonTable from "../../../components/comman/CommonTable";
import AddLeaveModal from "./AddLeaveModal";
import TopLable from "../../../components/comman/TopLable";
import EditIcon from "../../../components/Icons/EditIcon";
import {
  formatNumber,
  isEndDateGreater,
} from "../../../utility/CommonFunctions";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function MyLeave() {
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [modal, setModal] = useState({
    updateData: false,
    deleteData: false,
  });
  const navigate = useNavigate();
  const [state, setState] = useState({
    leaveCount: null,
    remainingLeave: [],
    leaveList: [],
    EditLeaveData: null,
    listType: [],
  });
  const [selectedId, setSelectedId] = useState("");
  const timeoutId = useRef(null);
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    filterData: "",
    searchQuery: "",
    sortByDate: [
      moment().subtract(1, "month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    leaveType: "",
  });
  const [filterData, setFilterData] = useState({
    sortByDate: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const toggleModal = (type) => {
    setModal((pre) => ({
      ...pre,
      ...(type === "delete"
        ? { deleteData: !pre.deleteData }
        : { updateData: !pre.updateData }),
    }));
  };

  const getLeaveCount = (type = null) => {
    const option = {
      method: "GET",
    };
    const url =
      apiUrl.get_leave_count +
      `?type=${type ? type : "leave"}&` +
      MainFilterHandler(filterData);
    callApi(url, option).then((res) => {
      if (res?.status === true) {
        setState((pre) => ({
          ...pre,
          ...(type
            ? {
              remainingLeave: res?.data?.map((item) => {
                return {
                  label: item?.leaveType,
                  value: formatNumber(+item?.remainingLeave),
                };
              }),
              listType: res?.data,
            }
            : { leaveCount: res.data }),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const getMyLeaveReq = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      `${apiUrl.get_leave}?` +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy }) +
      "&myLeave=true";
    setPageStates((pre) => ({
      ...pre,
      tableLoader: !pre.tableLoader,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: !pre.tableLoader,
      }));
      if (res?.status === true) {
        const newData = res?.data?.leave?.map((item) => ({
          ...item,
          // toggleStatus: item?.isActive,
          startDate1: moment(item.startDate).format("DD/MM/YYYY"),
          endDate1: moment(item.endDate).format("DD/MM/YYYY"),
          leaveStatus: item?.status,
        }));
        setState((pre) => ({
          ...pre,
          leaveList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "leaveType", label: "Leave Type" },
    { value: "startDate1", label: "From" },
    { value: "endDate1", label: "To" },
    { value: "reason", label: "Reason" },
    // { value: "approvedBy", label: "Approved by" },
    { value: "leaveStatus", label: "Status" },
  ];

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        currentPage: 1,
        searchQuery: value,
      }));
    }, 300);
  };

  useEffect(() => {
    getMyLeaveReq();
  }, [
    pageStates?.sortByDate,
    pageStates?.searchQuery,
    pageStates?.leaveType,
    pageStates.pageSize,
    pageStates.currentPage,
    filterDetails?.orderBy,
  ]);

  useEffect(() => {
    getLeaveCount();
    getLeaveCount("remaining");
  }, [filterData?.sortByDate]);

  const topLabelItems = [
    { label: "Total Leaves", value: state?.leaveCount?.total },
    { label: "Approved Leaves", value: state?.leaveCount?.approved },
    { label: "Pending Leaves", value: state?.leaveCount?.pending },
    { label: "Rejected Leaves", value: state?.leaveCount?.rejected },
    ...state?.remainingLeave,
  ];

  const handleEdit = (data) => {
    if (isEndDateGreater(data?.endDate)) {
      setState((pre) => ({ ...pre, EditLeaveData: data }));
      toggleModal();
    } else {
      toast.error("Can not update past leave request.");
    }
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleModal("delete");
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_leave + `?leaveId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        getLeaveCount();
        toggleModal("delete");
        getMyLeaveReq();
      } else {
        toast.error(response?.message);
        toggleModal("delete");
      }
    });
  };

  const redirectToView = (data) => {
    navigate(RoutesLink.leave_detail + `/${data?.id}`);
  };

  const ActionData = [
    {
      label: "View",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      // isShow: 'always',
      clickHandler: redirectToView,
    },
    {
      label: "Edit",
      className: "btn btn-link",
      icon: <EditIcon />,
      title: "edit",
      isShow: 0,
      isSiteEditable: false,
      clickHandler: handleEdit,
    },
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: 0,
      isSiteEditable: false,
      clickHandler: ActionHandler,
    },
  ];

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);

    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
      setFilterData((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
      setFilterData((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    }
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Leave"}
          buttonText={"Apply Leave"}
          // buttonIcon={<PlusIcon />}
          // buttonLink={RoutesLink?.add_customer}
          dateChangeHandler={dateChangeHandler}
          clickHandler={toggleModal}
        />
        <div className="row">
          {topLabelItems &&
            topLabelItems?.length > 0 &&
            topLabelItems?.map((data, i) => {
              return (
                <div key={i} className="col-12 col-md-3">
                  <div className="card dash-cards">
                    <div className="card-body">
                      <div className="d-flex align-items-center justify-content-between">
                        <h1>{data?.label}:</h1>
                        <h2>{data?.value}</h2>
                      </div>
                      {/* <p>From 01/04/2024</p> */}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleFilterForLeave={setPageStates}
              // dateChangeHandler={dateChangeHandler}
              handleSearch={handleSearchChange}
              leaveList={state?.listType}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={state?.leaveList}
              ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
      </div>
      <AddLeaveModal
        isOpen={modal?.updateData}
        onClose={toggleModal}
        EditLeaveData={state?.EditLeaveData}
        setState={setState}
        getLeave={getMyLeaveReq}
        getLeaveCount={getLeaveCount}
        state={state}
      />
      <ConfirmModal
        modal={modal.deleteData}
        toggle={() => toggleModal("delete")}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
